import { Box } from "@mui/material";
import { EntityTemplateStandardField, EntityTemplateStep, SystemStandardField } from "../../../entityTemplates/EntityTemplate.types.ts";
import { SystemModel } from "../SystemEdit.types.ts";
import StepSegment from "../../../processingActivity/stepSegment/StepSegment.tsx";
import { SystemFieldRenderer } from "../../../entityTemplates/SystemFieldRenderers.tsx";
import { ValidationError } from "../../../common/validationError.ts";

export interface SystemStepProps {
    systemId: string;
    isLoading: boolean;
    systemTemplateStep: EntityTemplateStep;
    system: SystemModel;
    onChange: (changeFunc: (system: SystemModel) => void) => Promise<void>;
    onCustomFieldChange: (changeFunc: (system: SystemModel) => void) => void;
    onRefetchSystem: () => void;
    validationErrors: Array<ValidationError>;
}

function SystemStep(props: SystemStepProps) {
    const largeStepSegments: EntityTemplateStandardField[] = [
        SystemStandardField.SystemSuppliers,
        SystemStandardField.SystemAssociatedAssets,
        SystemStandardField.SystemDataCategories,
        SystemStandardField.SystemPolicies,
    ];

    const fullWidthSteps: EntityTemplateStandardField[] = [SystemStandardField.SystemGroupCompanies];

    return (
        <>
            {props.systemTemplateStep.fields
                .sort((a, b) => a.order - b.order)
                .map((field) => {
                    const standardFieldIdentifier = field.standardFieldIdentifier;
                    const segmentSize = standardFieldIdentifier
                        ? largeStepSegments.includes(standardFieldIdentifier)
                            ? "large"
                            : fullWidthSteps.includes(standardFieldIdentifier)
                              ? "fullWidth"
                              : "small"
                        : "small";

                    return (
                        <StepSegment key={field.id} size={segmentSize}>
                            <Box key={field.id}>
                                <SystemFieldRenderer
                                    isLoading={props.isLoading}
                                    field={field}
                                    isPreview={false}
                                    system={props.system}
                                    systemId={props.systemId}
                                    onChange={props.onChange}
                                    onCustomFieldChange={props.onCustomFieldChange}
                                    onRefetchSystem={props.onRefetchSystem}
                                    validationErrors={props.validationErrors}
                                />
                            </Box>
                        </StepSegment>
                    );
                })}
        </>
    );
}

export default SystemStep;
